export default __webpack_public_path__ + "static/media/settings.3ce05398.svg";